/**
 * @generated SignedSource<<1960df6d4d8699143c45b603964b7e5b>>
 * @relayHash 7ba614836c690fbab956e7bd525f36be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1f58d99ee276da4036c48deb1856ec4395acdc64d53a16e90e91c3634e592bf3

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GraphQLTemplateContentAppearance = "DEFAULT" | "FULL_WIDTH" | "MAX" | "%future added value";
export type VariableInputDrawerComponentQuery$variables = {
  templateId: string;
};
export type VariableInputDrawerComponentQuery$data = {
  readonly template: {
    readonly body: {
      readonly atlas_doc_format: {
        readonly value: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly name: string | null | undefined;
    readonly templateId: string | null | undefined;
    readonly templatePropertySet: {
      readonly contentAppearance: GraphQLTemplateContentAppearance | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type VariableInputDrawerComponentQuery = {
  response: VariableInputDrawerComponentQuery$data;
  variables: VariableInputDrawerComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId"
  }
],
v1 = [
  {
    "alias": "template",
    "args": [
      {
        "kind": "Variable",
        "name": "contentTemplateId",
        "variableName": "templateId"
      }
    ],
    "concreteType": "ContentTemplate",
    "kind": "LinkedField",
    "name": "confluence_template",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "templateId"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "concreteType": "EnrichableMap_ContentRepresentation_ContentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentBody",
            "kind": "LinkedField",
            "name": "atlas_doc_format",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "TemplatePropertySet",
        "kind": "LinkedField",
        "name": "templatePropertySet",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "contentAppearance"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "VariableInputDrawerComponentQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VariableInputDrawerComponentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7ba614836c690fbab956e7bd525f36be",
    "id": "1f58d99ee276da4036c48deb1856ec4395acdc64d53a16e90e91c3634e592bf3",
    "metadata": {},
    "name": "VariableInputDrawerComponentQuery",
    "operationKind": "query",
    "text": "query VariableInputDrawerComponentQuery($templateId:String!){template:confluence_template(contentTemplateId:$templateId){templateId,name,body{atlas_doc_format{value}},templatePropertySet{contentAppearance}}}"
  }
};
})();

(node as any).hash = "bafa9cf0cc6b100c33f92219cd24070c";

export default node;
